import { parseBlob } from 'music-metadata-browser';
import type { ParsedTrackPayload } from '../types';

function parseFileName(fileName: string) {
  const stem = fileName.replace(/\.[^/.]+$/, '');
  const [artist, title] = stem.includes(' - ') ? stem.split(' - ', 2) : ['Unknown Artist', stem];

  return {
    title: title?.trim() || stem,
    artist: artist?.trim() || 'Unknown Artist'
  };
}

async function hashFile(file: File) {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export async function extractTrackFromFile(file: File): Promise<ParsedTrackPayload> {
  const fallback = parseFileName(file.name);
  const hash = await hashFile(file);

  try {
    const metadata = await parseBlob(file);
    const picture = metadata.common.picture?.[0];
    const artworkBlob =
      picture && picture.data
        ? new Blob([picture.data], { type: picture.format || 'image/jpeg' })
        : undefined;

    return {
      hash,
      title: metadata.common.title || fallback.title,
      artist: metadata.common.artist || fallback.artist,
      album: metadata.common.album || 'Unknown Album',
      duration: metadata.format.duration || 0,
      year: metadata.common.year,
      genre: metadata.common.genre?.[0],
      audioBlob: file,
      artworkBlob,
      fileName: file.name
    };
  } catch {
    return {
      hash,
      title: fallback.title,
      artist: fallback.artist,
      album: 'Unknown Album',
      duration: 0,
      audioBlob: file,
      fileName: file.name
    };
  }
}
